<template>
  <div
    :class="`${isHeader} tw-flex tw-justify-between tw-items-center tw-w-full tw-text-[#211f58] ${
      isHeader === ''
        ? 'tw-px-[20px] tw-py-5 sm:tw-px-10'
        : 'tw-pl-10 tw-pt-5 tw-pr-5 tw-pb-2'
    } tw-border-b-[#EFF0F1] tw-border-b ${
      title ? 'profileModal-header' : ''
    } ${classHeader}`"
  >
    <div
      :class="`tw-text-[18px] tw-font-semibold profileModal-header__title ${className}`"
    >
      {{ title }} <span class="tw-font-normal">{{ subTitle }}</span>
      <slot />
    </div>
    <div
      v-if="!hideClose"
      class="profileModal-header__close"
      :data-cy="dataCyClose"
      @click="$emit('close')"
    >
      <img class="tw-w-3 tw-h-3" src="@/assets/img/close.svg" alt="close" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({
  emits: ["close"],
})
export default class ModalHeader extends Vue {
  @Prop({ default: "" }) public title!: string;
  @Prop({ default: "" }) public subTitle!: string;
  @Prop({ default: false }) public hideClose!: boolean;
  @Prop({ default: "" }) public className?: string;
  @Prop({ default: "" }) public isHeader!: string;
  @Prop({ default: "" }) public classHeader!: string;
  @Prop({ default: "" }) public dataCyClose!: string;
}
</script>

<style lang="scss" scoped>
.profileModal-header {
  border-bottom: 1px solid #eff0f1 !important;
}

.profileModal-header__title {
  font-family: "Poppins";
  line-height: normal;
}

.profileModal-header__close {
  cursor: pointer;
}
.no__header {
  padding: 40px 20xp 20px 8px !important;
}
</style>
